export const destinationTrackingValues = (trackingValues) => {
  let value = [];

  if (trackingValues.Asia.length===46) {
    value.push('All Asia')
  }
  else {
    value = [...value, ...trackingValues.Asia]
  }

  if (trackingValues.Europe.length===49) {
    value.push('All Europe')
  }
  else {
    value = [...value, ...trackingValues.Europe]
  }

  if (trackingValues.Oceania.length===14) {
    value.push('All Oceania')
  }
  else {
    value = [...value, ...trackingValues.Oceania]
  }

  if (trackingValues['North America'].length===23) {
    value.push('All North America')
  }
  else {
    value = [...value, ...trackingValues['North America']]
  }

  if (trackingValues['South America'].length===12) {
    value.push('All South America')
  }
  else {
    value = [...value, ...trackingValues['South America']]
  }
  if (trackingValues.Africa.length===51) {
    value.push('All Africa')
  }
  else {
    value = [...value, ...trackingValues.Africa]
  }
  return defineTrackingValues(value);
}

export const defineTrackingValues = (value) => {
  let newValue = '';
  for (let i = 0; i < value.length; i++) {
    if (i===0) {
      newValue+=value[i];
    }
    else {
      newValue = newValue + ", " + value[i];
    }
  }
  return  newValue;
}

export const pushContinueButtonTracking = (category, value, trackingValues) => {
  if (category === "TravelPreference") {
    typeof window !== "undefined" && window.gtmDataLayer.push({'event': 'turbo', 'Travel Preferences': defineTrackingValues(value)})
  }
  if (category === "TravelledPlace") {
    typeof window !== "undefined" && window.gtmDataLayer.push({'event': 'turbo', 'Travelled Places': destinationTrackingValues(trackingValues)})
  }
  if (category === "BucketList") {
    typeof window !== "undefined" && window.gtmDataLayer.push({'event': 'turbo', 'Bucket List': destinationTrackingValues(trackingValues)})
  }
  if (category === "Reason") {
    typeof window !== "undefined" && window.gtmDataLayer.push({'event': 'turbo', 'Reason to Travel': defineTrackingValues(value)})
  }
  if (category === "Activity") {
    typeof window !== "undefined" && window.gtmDataLayer.push({'event': 'turbo', 'Activities': defineTrackingValues(value)})
  }
  if (category === "Topic") {
    typeof window !== "undefined" && window.gtmDataLayer.push({'event': 'turbo', 'Topics': defineTrackingValues(value)})
  }
}
